import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetDrawerIsOpen";
import { getCurrentUserIsGuest, getFulfillmentLabel, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Drawer, { DrawerPresentationProps, DrawerProps } from "@insite/mobius/Drawer";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import MapPin from "@insite/mobius/Icons/MapPin";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

const mapStateToProps = (state: ApplicationState) =>{
    const session = getSession(state);
    return {
    changeCustomerPageUrl : getPageLinkByPageType(state, "ChangeCustomerPage")?.url,
    userName: state.context.session.userName,
    billTo: getBillToState(state, session.billToId).value,
    currentUserIsGuest: getCurrentUserIsGuest(state),
}
};

const mapDispatchToProps = {
    setDrawerIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasShellContext;

export interface HeaderShipToAddressStyles {
    titleTypography?: InjectableCss;
    customerNumberWrapper?: InjectableCss;
}



export const headerShipToAddressStyles: HeaderShipToAddressStyles = {
    titleTypography: {
        css: css`
            margin-left: 10px;
            color:  ${getColor("primary.contrast")};
        `
    },
    customerNumberWrapper: {
        css: css`
         position: relative;
            &::after {
                position: absolute;
                right: -9px;
                top: 4px;
                content: "";
                width: 1px;
                height: 15px;
                border-right: 1px solid ${getColor("primary.contrast")};
            }
        `
    }
    
};

interface OwnProps extends WidgetProps {
    fields: {};
}

const HeaderWelcomeUsername: FC<Props> = ({
    changeCustomerPageUrl,
    userName,
    currentUserIsGuest,
    billTo
}) => {
    
    const styles = useMergeStyles("headerShipToAddress", headerShipToAddressStyles);

    return (
        <>
        {billTo && (
                <StyledWrapper {...styles.customerNumberWrapper}>
                    <Typography {...styles.titleTypography} data-test-selector="header_welcomeUsernameLabel">
                        {translate(`Customer #: ${billTo?.customerNumber}`)}
                    </Typography>
                </StyledWrapper>
            )
        }   
            
           
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withIsInShell(HeaderWelcomeUsername)),
    definition: {
        displayName: "Header Welcome Customer Number",
        icon: "User",
        group: "Common",
    },
};

export default widgetModule;
